import React from 'react';

import { Button, buttonClasses, ButtonProps, styled } from '@mui/material';

import { ReactComponent as SubmitIcon } from './arrow-icon.svg';

type Props = ButtonProps & {
  label: string;
};

const SubmitButton: React.FC<Props> = ({ children, label, ...rest }) => (
  <StyledSubmitButton variant="contained" {...rest}>
    <span>{label}</span>
    <SubmitIcon />
  </StyledSubmitButton>
);

export default SubmitButton;

const StyledSubmitButton = styled(Button)(({ theme }) => ({
  ...theme.typography.h6,
  width: '100%',

  svg: {
    display: 'none',
  },

  [theme.breakpoints.up('sm')]: {
    width: '60px',
    minHeight: '80px',
    gridRow: '1 / 3',
    gridColumn: '2 / 3',

    svg: { display: 'initial' },
    span: { display: 'none' },
  },

  [theme.breakpoints.up('md')]: {
    width: '60px',
    minHeight: '120px',
  },

  [`&.${buttonClasses.contained}`]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));
